export default class Toggle {
    constructor(Component) {
        this.Component  = Component;
        this._active    = false;
    }
    get container() { return this.Component.container }
    set active(active) {
        this._active = active;
        this.Component.render();
        if (active === true && this.container.dataset.toggleTime)
            setTimeout(() => { this.active = false; }, this.container.dataset.toggleTime);
    }
    get active() {
        return this._active;
    }
    set icon(icon) {
        this.Component.container.dataset.toggleIcon = icon;
    }
    set content(content) {
        this.Component.container.dataset.toggleContent = content;
        this.Component.render();
    }
    set type(type) {
        this.Component.container.dataset.toggleType = type;
    }
}
